/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {Model, ModelMixin} from '../../common/model.class';
import * as moment from 'moment';
import Moment = moment.Moment;

export class DeaRegistration extends ModelMixin() implements Model<DeaRegistration> {

    TYPE = DeaRegistration;

    registrationNumber?: string;
    dateIssued?: Moment;
    expirationDate?: Moment;

    constructor(jsonData: any = {}) {
        super();
        if (jsonData.dateIssued) jsonData.dateIssued = moment(jsonData.dateIssued);
        if (jsonData.expirationDate) jsonData.expirationDate = moment(jsonData.expirationDate);
        Object.assign(this, jsonData);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/dea/dea-registration.model.ts